import React, { useEffect, useState } from "react";
import { useParams, Link, Outlet, useNavigate } from "react-router-dom";
import apiClient from "../../Services/apiClient";
import { createServiceApplication } from "../../Services/dynamicservice"; 


function ServiceApplyPage() {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  apiClient
    .get(`services/${serviceId}`)
    .then((res) => {
      const schema = JSON.parse(res.data.formSchema || "[]");
      setService({ ...res.data, formSchema: schema });

      const initialForm = {};
      schema.forEach((f) => {
        initialForm[f.id] = f.type === "file" ? null : "";
      });
      setFormData(initialForm);
    })
    .catch((err) => console.error(err));
}, [serviceId]);

  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData({ ...formData, [name]: type === "file" ? files[0] : value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
      const user = JSON.parse(localStorage.getItem("user"));
    
    if (!user || !user.id) {
      console.error("User ID is missing. Please log in.");
    
      return;
    }

    const userId = user.id;

    const payload = new FormData();

    // 1. Non-file fields
    const normalFields = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value instanceof File) {
        // Files go directly to FormData
        payload.append(key, value);
      } else if (value !== null && value !== undefined && value !== "") {
        normalFields[key] = value;
      }
    });

    // 2. JSON only for normal fields
    payload.append("FormData", JSON.stringify(normalFields));

    // 3. Required fields as top-level form fields
    payload.append("ServiceId", serviceId || "");
    payload.append("UserId", userId);
    payload.append("PaymentAmount", String(service?.prices?.[0]?.price || 0));

    await createServiceApplication(payload);

    alert("Application submitted successfully!");
    navigate("/allserviceapplication");
  } catch (err) {
    console.error("Submission error:", err);
    alert(err.message || "Failed to submit application. Check console.");
  } finally {
    setLoading(false);
  }
};

  if (!service) return <p>Loading...</p>;

  // Split fields into rows of 3 columns (col-md-4)
  const chunkFields = (fields, size) => {
    const chunks = [];
    for (let i = 0; i < fields.length; i += size) {
      chunks.push(fields.slice(i, i + size));
    }
    return chunks;
  };

  const fieldRows = chunkFields(service.formSchema, 3);

  return (
    <div>
      <div className="wrapper">
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">

              {/* PAGE TITLE */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item active">{service.name}</li>
                      </ol>
                    </div>
                    <h4 className="page-title">{service.name}</h4>
                  </div>
                </div>
              </div>

              {/* FORM */}
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <form onSubmit={handleSubmit} encType="multipart/form-data">
                        {fieldRows.map((row, idx) => (
                          <div className="row g-2 mb-3" key={idx}>
                            {row.map((field) => (
                              <div
                                className={`mb-3 col-md-${field.type === "textarea" ? 8 : 4}`}
                                key={field.id}
                              >
                                <label className="form-label">{field.label}</label>
                                {field.type === "textarea" ? (
                                  <textarea
                                    className="form-control"
                                    name={field.id}
                                    value={formData[field.id]}
                                    required={field.required}
                                    placeholder={field.placeholder || ""}
                                    onChange={handleInputChange}
                                    rows={2}
                                  />
                                ) : field.type === "file" ? (
                                  <input
                                    type="file"
                                    className="form-control"
                                    name={field.id}
                                    required={field.required}
                                    onChange={handleInputChange}
                                  />
                                ) : field.type === "select" && field.options?.length > 0 ? (
                                  <select
                                    className="form-control"
                                    name={field.id}
                                    value={formData[field.id]}
                                    required={field.required}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">Select {field.label}</option>
                                    {field.options.map((opt) => (
                                      <option value={opt.value} key={opt.value}>
                                        {opt.label}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <input
                                    type={field.type}
                                    className="form-control"
                                    name={field.id}
                                    value={formData[field.id]}
                                    required={field.required}
                                    placeholder={field.placeholder || ""}
                                    onChange={handleInputChange}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        ))}

                        <button type="submit" className="btn btn-primary" disabled={loading}>
                          {loading ? "Submitting..." : "Submit Application"}
                        </button>

                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
}

export default ServiceApplyPage;
